import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoogleLoginButton from './GoogleLoginButton';
import './Auth.css';

function AuthLanding() {
  const navigate = useNavigate();

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>REACH AI-Health Assistant (এআই স্বাস্থ্য সহকারী)</h1>
        <p>
          Access reliable health guidance instantly, with or without an account. <br />
          <span style={{ fontSize: '0.95em', color: '#555' }}>
            অ্যাকাউন্ট থাকুক বা না থাকুক, তৎক্ষণাৎ নির্ভরযোগ্য স্বাস্থ্য পরামর্শ পান।
          </span>
        </p>

        {/* Primary actions */}
        <div className="auth-actions">

          <button
            type="button"
            className="auth-btn"
            onClick={() => navigate('/login')}
          >
            Login (লগইন)
          </button>

          <button
            type="button"
            className="auth-btn"
            onClick={() => navigate('/register')}
          >
            Sign Up (নিবন্ধন করুন)
          </button>
        </div>

        <div className="divider">OR (অথবা)</div>

        {/* Google login */}
        <div className="auth-actions">
          <GoogleLoginButton />
        </div>

        <div className="divider">OR (অথবা)</div>

        {/* Guest access */}
        <div className="auth-actions">
          <button
            type="button"
            className="auth-btn guest-btn"
            onClick={() => navigate('/chat')}
          >
            Skip to Chatbot (চ্যাটবটে সরাসরি যান)
          </button>
        </div>

        <p className="guest-note">
          Guest access has limited features <br />
          <span style={{ fontSize: '0.9em', color: '#666' }}>
            অতিথি ব্যবহারকারীদের জন্য কিছু সীমিত সুবিধা প্রযোজ্য
          </span>
        </p>
      </div>
    </div>
  );
}

export default AuthLanding;
